import { connect } from 'react-redux';
import About from './About';


let mapStateToProps = (state) => {
  return {
    productsData: state.productsPage.productsData,
    aboutData: state.aboutPage.aboutData
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const AboutContainer = connect(mapStateToProps, mapDispatchToProps)(About);

export default AboutContainer;